import { Wallet } from "lucide-react";
import { useTranslation } from "react-i18next";
import { computeWalletPlanCharge } from "@/lib/billing/computeWalletPlanCharge";
import { walletPlanDiscountPercent } from "@/lib/billing/walletPlanDiscountPercent";
import { cn } from "@/lib/utils";

interface WalletPlanDiscountNoteProps {
  plan: { slug?: string | null; name?: string | null };
  priceReais: number;
  formatCurrency: (value: number) => string;
  className?: string;
}

export function WalletPlanDiscountNote({
  plan,
  priceReais,
  formatCurrency,
  className,
}: WalletPlanDiscountNoteProps) {
  const { t } = useTranslation();
  const percent = walletPlanDiscountPercent(plan);
  const priceCents = Math.round(priceReais * 100);
  if (!percent || priceCents <= 0) return null;

  const charge = computeWalletPlanCharge({
    priceCents,
    availableCents: priceCents,
    discountPercent: percent,
  });

  return (
    <p
      className={cn(
        "mt-2 inline-flex items-center justify-center gap-1.5 text-xs font-semibold text-lime-600 dark:text-lime-400",
        className,
      )}
    >
      <Wallet className="h-3.5 w-3.5 shrink-0" />
      {t("pricing.walletDiscount", {
        percent,
        price: formatCurrency(charge.appliedCents / 100),
      })}
    </p>
  );
}
